module.exports = __webpack_public_path__ + "static/media/1700.bcf5ac90.jpg";